import { render, staticRenderFns } from "./BaseHtmlEditor.vue?vue&type=template&id=31577dc6"
import script from "./BaseHtmlEditor.vue?vue&type=script&lang=ts"
export * from "./BaseHtmlEditor.vue?vue&type=script&lang=ts"
import style0 from "./BaseHtmlEditor.vue?vue&type=style&index=0&id=31577dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports